import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import baseURL from "../../config";
import {
  Box,
  Typography,
  Card,
  IconButton,
  useTheme,
  useMediaQuery,
  Divider,
  Tooltip,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import {
  Edit,
  Menu,
  Person,
  Description,
  Logout,
} from "@mui/icons-material";
import Navbar from "../../Navbar/Navbar.jsx";
import CrewProfileSection from "./CrewProfileSection.jsx";
import CrewContractSection from "./CrewContractSection.jsx";
import SignOnSignOffSection from "./SignOnSignOffSection.jsx";
import CrewFeedbackForm from "./CrewFeedbackForm.jsx";


const CrewInfo = () => {
  const { id } = useParams();
  const [crewData, setCrewData] = useState(null);
  const [contractData, setContractData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const drawerWidth = 260;

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);

      try {
        const profileRes = await axios.get(`${baseURL}/api/crewprofileById/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCrewData(profileRes.data);
        // console.log("profileRes.data", profileRes.data);
      } catch (err) {
        console.error("Error fetching crew profile:", err);
        setCrewData(null);
      }

      try {
        const contractRes = await axios.get(`${baseURL}/api/contracts/crew/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setContractData(contractRes.data);
        // console.log("contractRes.data", contractRes.data);
      } catch (err) {
        console.error("Error fetching crew contract:", err);
        setContractData([]); // Optional: [] or null depending on UI
      }

      setLoading(false);
    };

    if (id) {
      fetchData();
    }
  }, [id]);


  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleEditClick = () => {
    navigate("/crewprofile", {
      state: { crewProfile: crewData, from: "CrewInfo" },
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <>
      <Box sx={{ width: "100%", zIndex: theme.zIndex.appBar }}>
        <Navbar />
      </Box>

      <Box sx={{ display: "flex", bgcolor: "#f5f7fa" }}>
        {/* Sidebar */}
        <Box
          sx={{
            width: drawerOpen ? drawerWidth : 60,
            height: "calc(100vh - 64px)",
            bgcolor: "white",
            color: "black",
            boxShadow: 6,
            transition: "width 0.3s",
            overflowX: "hidden",
            pt: 3,
            position: "fixed",
            top: "64px",
            left: 0,
            zIndex: 1200,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 4, px: 2 }}
          >
            <Tooltip title={drawerOpen ? "Collapse Sidebar" : "Expand Sidebar"}>
              <IconButton onClick={toggleDrawer}>
                <Menu />
              </IconButton>
            </Tooltip>

            {drawerOpen && (
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ color: 'black', whiteSpace: 'nowrap', ml: 1 }}
              >
                Crew Info Panel
              </Typography>
            )}
          </Box>


          <List component="nav">
            <ListItemButton
              selected={selectedTab === 0}
              onClick={() => setSelectedTab(0)}
              sx={{
                borderRadius: 2,
                p: drawerOpen ? 1.5 : 1,
                justifyContent: drawerOpen ? "initial" : "center",
                '&:hover': {
                  bgcolor: 'grey.100',
                  color: '#C30B12',
                  '& svg': { color: '#C30B12' },
                },
              }}
            >
              <ListItemIcon sx={{ color: '#C30B12', minWidth: drawerOpen ? 36 : "auto", justifyContent: "center" }}>
                <Person />
              </ListItemIcon>
              {drawerOpen && <ListItemText primary="Profile" />}
            </ListItemButton>

            <ListItemButton
              selected={selectedTab === 1}
              onClick={() => setSelectedTab(1)}
              sx={{
                borderRadius: 2,
                p: drawerOpen ? 1.5 : 1,
                justifyContent: drawerOpen ? "initial" : "center",
                '&:hover': {
                  bgcolor: 'grey.100',
                  color: '#C30B12',
                  '& svg': { color: '#C30B12' },
                },
              }}
            >
              <ListItemIcon sx={{ color: '#C30B12', minWidth: drawerOpen ? 36 : "auto", justifyContent: "center" }}>
                <Description />
              </ListItemIcon>
              {drawerOpen && <ListItemText primary="Contract" />}
            </ListItemButton>

            <ListItemButton
              selected={selectedTab === 2}
              onClick={() => setSelectedTab(2)}
              sx={{
                borderRadius: 2,
                p: drawerOpen ? 1.5 : 1,
                justifyContent: drawerOpen ? "initial" : "center",
                '&:hover': {
                  bgcolor: 'grey.100',
                  color: '#C30B12',
                  '& svg': { color: '#C30B12' },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: '#C30B12',
                  minWidth: drawerOpen ? 36 : "auto",
                  justifyContent: "center",
                }}
              >
                <Description /> {/* Replace with a better icon if needed */}
              </ListItemIcon>
              {drawerOpen && <ListItemText primary="Sign On / Sign Off" />}
            </ListItemButton>

            <ListItemButton
              selected={selectedTab === 3}
              onClick={() => setSelectedTab(3)}
              sx={{
                borderRadius: 2,
                p: drawerOpen ? 1.5 : 1,
                justifyContent: drawerOpen ? "initial" : "center",
                '&:hover': {
                  bgcolor: 'grey.100',
                  color: '#C30B12',
                  '& svg': { color: '#C30B12' },
                },
              }}
            >
              <ListItemIcon sx={{ color: '#C30B12', minWidth: drawerOpen ? 36 : "auto", justifyContent: "center" }}>
                <Description />
              </ListItemIcon>
              {drawerOpen && <ListItemText primary="Feedback Form" />}
            </ListItemButton>

            <Divider sx={{ my: 2 }} />

            <Button
              fullWidth
              startIcon={<Logout />}
              onClick={handleLogout}
              sx={{
                color: 'red',
                borderRadius: 2,
                p: 1.5,
                textAlign: 'left',
                justifyContent: drawerOpen ? "flex-start" : "center",
                '&:hover': {
                  bgcolor: 'error.main',
                  color: 'white',
                },
              }}
            >
              {drawerOpen ? "Logout" : null}
            </Button>
          </List>
        </Box>

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 4,
            overflowY: "auto",
            marginLeft: drawerOpen ? `${drawerWidth}px` : "60px",
            mt: "64px",
            transition: "margin 0.3s",
          }}
        >
          <Card
            elevation={3}
            sx={{
              p: 3,
              borderRadius: 3,
              bgcolor: "white",
              maxWidth: "100%",
              mx: "auto",
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                mb: 2,
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#2c3e50" }}>
                {selectedTab === 0
                  ? "Crew Profile"
                  : selectedTab === 1
                    ? "Contract Details"
                    :selectedTab === 3
                  ? "Crew Feedback"
                    : "Sign On / Sign Off"}
              </Typography>

              {/* {selectedTab === 0 && (
                <Tooltip title="Edit Crew Info">
                  <IconButton color="primary" onClick={handleEditClick}>
                    <Edit />
                  </IconButton>
                </Tooltip>
              )} */}
            </Box>

            <Divider sx={{ mb: 3 }} />
            {loading ? (
              <Typography>Loading...</Typography>
            ) : selectedTab === 0 ? (
              <CrewProfileSection crewData={crewData} handleEditClick={handleEditClick} />
            ) : selectedTab === 1 ? (
              <CrewContractSection contractData={contractData} />
            ) : selectedTab === 3 ? (
              <CrewFeedbackForm />
            ) : (
              <SignOnSignOffSection crewId={id} />
            )}

          </Card>
        </Box>
      </Box>
    </>
  );
};

export default CrewInfo;
